<template>
  <div class="order-review">
    <div class="info">作業終了前までに口コミを入れていただけましたら、<span class="info-red">『本日の作業代金を500円割引き』</span>させていただきます。<br>
      良い場合も、良くない場合も、{{ customerName }}の口コミが私たちの業務改善につながりますので、ぜひ投稿くださいませ。<br>
      なお、作業完了後に口コミ投稿された方には、毎月抽選で<span class="info-red">『QUOカード500円分プレゼント』</span>します！
    </div>
    <img :src="review_qr_src" alt="QR" class="text-center">
    <div class="floating-actions settled">
      <button type='button' class='btn btn-danger'
              @click='cancel'>
        閉じる
      </button>
    </div>
  </div>
</template>

<script>
export default {
  props: ['order', 'step'],
  data: function () {
    return {
      review_qr_src: ''
    }
  },
  computed: {
    customerName: function () {
      if (this.order.customer_name) {
        return this.order.customer_name.trim() + 'さま'
      }
      return 'あなた'
    }
  },
  name: "OrderReview",
  methods: {
    cancel: function () {
      if (this.step === 'payment') {
        this.$route.params['finishCampaign'] = true
        this.$router.push({
          name: 'payment',
          params: this.$route.params
        });
      } else {
        this.$router.push({name: 'orderSteps'});
      }
    }
  },
  created: function () {
    if (!this.order) this.$router.push({name: 'orderSteps'})
  },
  mounted: function () {
    this.review_qr_src = "data:image/png;base64," + this.order.info_steps[4].review_qr_src;
    this.$$.context({
      title: "ID:" + this.$route.params.id,
      previousRouteName: 'orderSteps',
    });
  }
}
</script>

<style lang='scss'>
.order-review {
  padding: 1em 2em;
  max-width: 480px;
  margin: auto;

  .info {
    margin: 1em;
  }

  .btn {
    min-width: 10em;
  }

  .text-center {
    display: block;
    margin: auto;
  }

  .info-red {
    color: red;
    font-size: 1.2rem;
  }
}
</style>